import { useLang } from "../lib/i18n";
import { IMAGES } from "../lib/images";
import { GARAGE_COLORS } from "../lib/garageColors";
import { Systems, ColourPalette } from "./Fenetres";

export default function PortesGarage() {
  const { t } = useLang();
  return (
    <>
      <Systems s={t.garagePage.systems} images={IMAGES.garagePage.systems} />
      <ColourPalette
        c={t.garagePage.colours}
        colors={GARAGE_COLORS}
        texBase="/garage-colors/gc-"
      />
    </>
  );
}
